<div class="spinner-container" *ngIf="loaderService.loading$ | async">
    <mat-spinner style="color: blueviolet;"></mat-spinner>
</div>